/**
 * Canonical public URLs for persona pages (flat /:slug, not /personas/:slug).
 */

export function getPersonaHref(slug?: string | null): string {
  if (!slug) return '/'
  return `/${slug}`
}

export function getPersonaCanonicalPath(slug: string): string {
  return `/${slug}`
}
